import { render } from "./ViewManufacturer.vue?vue&type=template&id=587e6377"
import script from "./ViewManufacturer.vue?vue&type=script&lang=js"
export * from "./ViewManufacturer.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__